
import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import CustomFieldMixin from '@/mixins/CustomFieldMixin';

@Component
export default class TextareaField extends mixins(CustomFieldMixin) {}
